exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".journal-entry-grid[data-v-15c29cf3]{grid-gap:0}.journal-entry-grid div[data-v-15c29cf3]{border:1px solid #e0e0e0;border-left:0;padding-left:1rem}.journal-entry-grid div[data-v-15c29cf3]:nth-child(2n){border-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15c29cf3","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/accounting/general-ledger/journal-entry/JournalEntryDetails.vue
// module id = Tf9V
// module chunks = 0 1